/* eslint-disable react/prop-types */
import Button, { ButtonType } from "../../../components/Button/Button";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import { Address } from "../../../interfaces/interfaces";
import EditIcon from "../../../assets/edit";
import TrashWhite from "../../../assets/trashWhite";
import ShippingFast from "../../../assets/shippingFast";

interface AddressBookListProps {
  savedAddresses: Address[];
  isLoading: boolean;
  onEditAddress: (address: Address) => void;
  onDeleteAddress: (address: Address) => void;
}

const AddressBookList: React.FC<AddressBookListProps> = ({
  savedAddresses,
  isLoading,
  onEditAddress,
  onDeleteAddress,
}) => {
  if (isLoading) {
    return (
      <div className="address-book-loading">
        <LoadingSpinner />
        <p>Loading your addresses...</p>
      </div>
    );
  }

  if (savedAddresses.length === 0) {
    return (
      <div className="address-book-empty">
        <div className="empty-state-icon">
          <ShippingFast width={64} height={64} />
        </div>
        <h3 className="empty-state-title">No addresses saved</h3>
        <p className="empty-state-description">
          Add your first shipping address to get started. You can save multiple addresses for faster
          checkout.
        </p>
      </div>
    );
  }

  return (
    <div className="address-book-list">
      {savedAddresses.map((address, index) => (
        <div key={address.id || index} className="address-card">
          <div className="address-card-content">
            <div className="address-card-header">
              <h3 className="address-card-name">{address.ship_to_name}</h3>
            </div>
            {address.is_primary_address && <span className="address-card-badge">Primary</span>}
            <div className="address-card-details">
              {address.address_line1 && <div>{address.address_line1}</div>}
              {address.address_line2 && <div>{address.address_line2}</div>}
              {address.address_line4 && <div>{address.address_line4}</div>}
              {(address.address_postcode || address.address_city) && (
                <div>
                  {[address.address_city, address.address_postcode].filter(Boolean).join(" ")}
                </div>
              )}
              {address.address_country && <div>{address.address_country}</div>}
            </div>
          </div>
          <div className="address-card-actions">
            <Button
              type={ButtonType.secondary}
              onClick={() => onEditAddress(address)}
              className="address-card-edit-btn"
            >
              <EditIcon width={16} height={16} />
              <span>Edit</span>
            </Button>
            <Button
              type={ButtonType.danger}
              onClick={() => onDeleteAddress(address)}
              className="address-card-delete-btn"
            >
              <TrashWhite width={16} height={16} />
              <span>Delete</span>
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AddressBookList;
